import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { CreateGroupAPI } from '../api/group/creategroup/creategroupapi';
import { CreateGroupRequest } from '../api/group/creategroup/creategrouprequest';
import { CreateGroupResponse } from '../api/group/creategroup/creategroupresponse';
import { DeleteGroupAPI } from '../api/group/deletegroup/deletegroupapi';
import { DeleteGroupRequest } from '../api/group/deletegroup/deletegrouprequest';
import { DeleteGroupResponse } from '../api/group/deletegroup/deletegroupresponse';
import { EditGroupAPI } from '../api/group/editgrop/editgroupapi';
import { EditGroupRequest } from '../api/group/editgrop/editgrouprequest';
import { EditGroupResponse } from '../api/group/editgrop/editgroupresponse';
import { APIProcessor } from '../processor/apiProcessor';
import { CreateGroupAPIProcessorImpl } from '../processor/creategroupapiprocessor';
import { DeleteGroupAPIProcessorImpl } from '../processor/deletegroupapiprocessor';
import { EditGroupAPIProcessorImpl } from '../processor/editgroupapiprocessor';
import { ProcessorFactoryImpl } from './processorfactory';

export class GroupProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(GroupProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getCreateGroupAPIProcessor():APIProcessor<CreateGroupRequest, CreateGroupResponse>
    {
        this.logger.log("getCreateGroupAPIProcessor() invoked");
        return new CreateGroupAPIProcessorImpl(this.getContext(), new CreateGroupAPI(this.getHttpClient(), this.getContext()));
    }

    getEditGroupAPIProcessor():APIProcessor<EditGroupRequest, EditGroupResponse>
    {
        this.logger.log("getEditGroupAPIProcessor() invoked");
        return new EditGroupAPIProcessorImpl(this.getContext(), new EditGroupAPI(this.getHttpClient(), this.getContext()));
    }

    getDeleteGroupAPIProcessor():APIProcessor<DeleteGroupRequest, DeleteGroupResponse>
    {
        this.logger.log("getDeleteGroupAPIProcessor() invoked");
        return new DeleteGroupAPIProcessorImpl(this.getContext(), new DeleteGroupAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/groupprocessorfactory.tsx